import React from 'react';
import PropTypes from 'prop-types';

import capitalize from 'lodash/capitalize';

import Dropdown from 'components/dropdown';
import StageSelect from 'bundles/apex/stage_select';
import StatusSelect from 'bundles/apex/playbooks/config/status_select';

function CopyTaskSelects({
  label,
  playbookRecordType,
  playbookType,
  playbookTypeOptions,
  stage,
  stages,
  status,
  statusOptions,
  onPlaybookTypeChange,
  onTargetChange,  
}) {
  return (
    <div className="d-flex align-items-center">
      <h6>{label}</h6>
      <Dropdown
        className="ms-2"
        label={playbookTypeOptions.find(option => option.value === playbookType)?.label}
      >
        {playbookTypeOptions.map(option => (
          <Dropdown.Item
            key={option.value}
            label={capitalize(option.label)}
            name={option.value}
            onClick={() => onPlaybookTypeChange(option.value)}
          />
        ))}
      </Dropdown>
      {playbookRecordType === 'deal'
        ? <StageSelect setStage={onTargetChange} stage={stage} stages={stages} />
        : (
          <StatusSelect
            listingType={playbookType}
            setStatus={onTargetChange}
            status={status}
            statusOptions={statusOptions}
          />
        )
      }
    </div>
  );
}

CopyTaskSelects.propTypes = {
  label: PropTypes.string.isRequired,
  playbookRecordType: PropTypes.string.isRequired,
  playbookType: PropTypes.string.isRequired,
  playbookTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  stage: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  stages: PropTypes.object,
  status: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  statusOptions: PropTypes.array,
  onPlaybookTypeChange: PropTypes.func.isRequired,
  onTargetChange: PropTypes.func.isRequired,
};

export default CopyTaskSelects;
